// errors/MultipleBaseError.ts
import { BaseError } from "./BaseError.js";
var MultipleBaseError = class extends BaseError {
  static {
    this._class = "MultipleBaseError";
  }
  constructor(errors) {
    super(errors.map((err) => err.toString()).join("\n------\n"), { errors, translationKey: "multipleErrors" });
  }
  static createFromDetails(message, extensions) {
    return new this(extensions.errors);
  }
  toString() {
    return this.message;
  }
};
export {
  MultipleBaseError
};
